export default "__VITE_ASSET__8671846a__"